import { Table } from "@tanstack/react-table";
import React from "react";
import { FormCheckbox } from "../forms/FormCheckbox/FormCheckbox";

interface ViewTableCheckboxHeaderProps<TData> {
    readonly table: Table<TData>;
}

export function ViewTableCheckboxHeader<TData>({
    table,
}: ViewTableCheckboxHeaderProps<TData>) {
    return (
        <FormCheckbox
            value="all"
            isChecked={table.getIsAllPageRowsSelected()}
            isPartiallyChecked={table.getIsSomePageRowsSelected()}
            handleChangeEvent={table.getToggleAllPageRowsSelectedHandler()}
            small
            preventClickPropagation
        />
    );
}
